import {
  MarketingContentCardTile,
  Maybe,
  TileStatus,
  TileType,
} from '@varo/graphql-schema-types';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import { BrazeCardProps } from 'shared/components/vxl/cards/BrazeCard/BrazeCard';
import { CardType } from 'shared/components/vxl/cards/BrazeCard/BrazeCard.constants';
import {
  VXLPromoCardColorTheme,
  VXLPromoCardProps,
} from 'shared/components/vxl/cards/VXLPromoCard/VXLPromoCard';
import { VXLComponent, VXLComponentId } from 'shared/renderer/types';

interface ContentCardTileNode extends VXLComponent {
  id: string;
  name: VXLComponentId.BRAZE_CARD | VXLComponentId.VXL_PROMO_CARD;
  props: BrazeCardProps | VXLPromoCardProps;
}

const getCardType = (type: string): CardType => {
  if (Object.values(CardType).includes(type as CardType)) {
    return type as CardType;
  }
  return CardType.Blush;
};

const getCardTypePromoCard = (type: string): VXLPromoCardColorTheme => {
  const colors = ['white', 'grey'];
  if (Object.values(colors).includes(type as VXLPromoCardColorTheme)) {
    return type as VXLPromoCardColorTheme;
  }
  return 'white';
};

const marketingContentCardTile = (
  tile: MarketingContentCardTile,
  {
    logContentCardClicked,
    logContentCardDismissed,
    logContentCardImpression,
    brazeContentCards,
    isHomeRedesignPhase1Enabled,
  }: HomeCardDependencies,
): Maybe<ContentCardTileNode> => {
  const contentCard = brazeContentCards[0];

  if (
    tile.status !== TileStatus.Loaded ||
    tile.tileType !== TileType.MarketingContentCard ||
    !contentCard
  ) {
    return null;
  }

  const {
    title,
    description,
    ctaTitle,
    isDismissible,
    imageUrl,
    cardBackground,
  } = contentCard;

  const cardTile: ContentCardTileNode = isHomeRedesignPhase1Enabled
    ? {
        id: tile.id,
        name: VXLComponentId.VXL_PROMO_CARD,
        props: {
          bodyText: description as string,
          actionText: ctaTitle as string,
          colorTheme: getCardTypePromoCard(cardBackground as string),
          onPress: (): void => {
            logContentCardClicked(contentCard);
          },
          onDismiss: isDismissible
            ? (): void => logContentCardDismissed(contentCard)
            : undefined,
          illustration: imageUrl ? { uri: imageUrl } : undefined,
        },
      }
    : {
        id: tile.id,
        name: VXLComponentId.BRAZE_CARD,
        props: {
          cardType: getCardType(cardBackground as string),
          headlineText: title as string,
          bodyText: description as string,
          button: {
            label: ctaTitle as string,
            isDisabled: false,
            isLoading: false,
            onPress: () => {
              logContentCardClicked(contentCard);
            },
          },
          onDismiss: isDismissible
            ? () => logContentCardDismissed(contentCard)
            : undefined,
          onAppear: () => {
            logContentCardImpression(contentCard);
          },
          imageSource: imageUrl ? { uri: imageUrl } : undefined,
        },
      };

  return cardTile;
};

export default marketingContentCardTile;
